"use client";

import { track } from "@vercel/analytics";
import { useEffect } from "react";

import { currentCampaign, readCampaignTag } from "@/lib/campaign-source";

/**
 * One named event when a funnel page is viewed, carrying where the visitor came from.
 *
 * A page view on its own already exists in Vercel Analytics, but it cannot be grouped by the
 * source that sent the visitor, which is the one question the funnel report has to answer
 * ("how many people did Tom's LinkedIn bring to the briefing?"). The source is read from the
 * address first, because this effect can run before ReferralTracker has remembered the tag.
 */
export function FunnelViewTracker({ event }: { event: string }) {
  useEffect(() => {
    const fromUrl = readCampaignTag(new URLSearchParams(window.location.search));
    const tag = fromUrl ?? currentCampaign();
    track(event, { source: tag?.source ?? "direct", medium: tag?.medium ?? "none" });
  }, [event]);
  return null;
}
